import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'

import Component from '../components/delivery'
import actions from '../actions/delivery'
import orchestratorActions from '../actions/orchestrator'
import pickupActions from '../actions/pickup'

class Container extends React.Component {

  constructor(props) {
    super(props)
    props.getUnavailableDates()
  }

  render() {
    return <Component {...this.props}/>
  }

  static propTypes = {
    getUnavailableDates: PropTypes.func.isRequired,
  }
}

const mapStateToProps = state => {
  const data = state.ui.rent.delivery
  const reservationData = state.ui.rent.reservation
  const rent = state.ui.rent.orchestrator.get('rent')
  return {
    dateSelected: data.get('date'),
    unavailableDates: data.get('unavailableDates').toArray(),
    timeslotSelected: data.get('timeslot'),
    timeslots: data.get('timeslots').toArray(),
    isFetchingDates: data.get('isFetchingDates') || reservationData.get('isLoading'),
    isFetchingTimeslots: data.get('isFetchingTimeslots'),
    isButtonLoading: data.get('isModifying'),
    isButtonDisabled: data.get('isFetchingDates') || reservationData.get('isLoading') || data.get('isFetchingTimeslots'),
    error: data.get('error'),
    address: rent ? rent.get('Address').Address : '',
  }
}

const mapDispatchToProps = dispatch => {
  return {
    selectDate: date => dispatch(actions.selectDate(date)),
    selectTimeslot: timeslot => dispatch(actions.selectTimeslot(timeslot)),
    getUnavailableDates: () => dispatch(actions.getUnavailableDates()),
    getTimeslots: () => dispatch(actions.getTimeslots()),
    modifyTransaction: () => {
      dispatch(actions.modifyTransaction()) //TODO fix this everywhere else, chaining then's and catch's does not work
        .then(() => {
          dispatch(orchestratorActions.nextStepFromDelivery())
          dispatch(pickupActions.selectDate(null))
        }, error => {})
    },
    setStep: step => dispatch(orchestratorActions.setStep(step)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/rent/containers/delivery.js